import { BASE_URL } from "../constants";
import { LokasiEntity } from "../entities/LokasiEntity";
import FetchUtils from "../utils/fetch";

class LokasiService {
    static async GetAllLokasi(): Promise<LokasiEntity[]> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/lokasis`);
        if (resp.status != 200) { throw resp.message }

        const data: LokasiEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new LokasiEntity({
                id: resp.data[i].ID,
                lokasi: resp.data[i].Lokasi,
            }))
        }

        return data;
    }

    static async AddLokasi(data: { lokasi: string }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/lokasis/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async UpdateLokasi(data: LokasiEntity, fields: { lokasi?: string}): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/lokasis/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteLokasi(data: LokasiEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/lokasis/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

export { LokasiService };